var _style, _linearGradient, _path, _linearGradient2, _path2, _linearGradient3, _path3, _linearGradient4, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGooglePlayLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "-29.45 0 466.9 466.9",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st0{fill:url(#SVGID_1_)}.st1{fill:url(#SVGID_2_)}.st2{fill:url(#SVGID_3_)}.st3{fill:url(#SVGID_4_)}")), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    y1: 112.094,
    x2: 261.746,
    y2: 112.094
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#63be6b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.506,
    stopColor: "#5bbc6a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ab96a"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M261.7 142.3L15 1.3C11.9-.5 8-.4 5 1.4c-3.1 1.8-5 5-5 8.6 0 0 .1 13 .2 34.4l179.7 179.7 81.8-81.8z"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 0.152,
    y1: 223.393,
    x2: 179.896,
    y2: 223.393
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3ec6f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45afe3"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M.2 44.4C.5 121.6 1.4 309 1.8 402.3L180 224.1.2 44.4z"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 179.896,
    y1: 229.464,
    x2: 407.976,
    y2: 229.464
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#faa51a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.387,
    stopColor: "#fab716"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.741,
    stopColor: "#fac412"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fac80f"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M402.9 223l-141.2-80.7-81.9 81.8 92.4 92.4L403 240.3c3.1-1.8 5-5.1 5-8.6 0-3.6-2-6.9-5.1-8.7z"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 1.744,
    y1: 345.521,
    x2: 272.296,
    y2: 345.521
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ec3b50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e7515b"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1.7 402.3c.2 33.3.3 54.6.3 54.6 0 3.6 1.9 6.9 5 8.6 3.1 1.8 6.9 1.8 10 0l255.3-148.9-92.4-92.4L1.7 402.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlayLogo);
export default __webpack_public_path__ + "static/media/google-play-logo.6623522cbdbb1ca4e6681688696d03fb.svg";
export { ForwardRef as ReactComponent };